import React, { useEffect, useState } from 'react';
import { api, apiJson } from '../../app/Api/ApiSlice';
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroll-component';
import UserCard from '../../components/UserCard';
import Loader from '../../components/Loader';
import { useParams } from 'react-router-dom';
import "./user.css"

const MyFollowings = () => {
    const [myFollowings, setMyFollowings] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(false)
    const [page, setPage] = useState(1)
    const [isFriend, setIsFriend] = useState(null)
    const [isFollowing, setIsFollowing] = useState(null)

    const { user } = useParams()

    useEffect(() => {
        const getMyFollowings = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/community/followings`, { params: { page } });
                setMyFollowings(response?.data);

                if (response?.data.length < 20) {
                    setHasMore(false)
                }
            } catch (error) {
                // console.log(error)
                toast.error(error.response?.data?.message || "Failed to fetch followings");
            } finally {
                setIsLoading(false);
            }
        };

        getMyFollowings();
    }, [page, user]);

    const handleRefresh = async () => {
        setPage(1)
        setMyFollowings([])
    }

    const sendUnfollowRequest = async (id) => {
        try {
            console.log(id)
        } catch (error) {

        }
    }

    return (
        <div className='users-page-container'>
            <div className="userfriends-header">
                <h3>People i'm following</h3>
            </div>
            <InfiniteScroll
                dataLength={myFollowings.length}
                next={() => setPage((prev) => prev + 1)}
                hasMore={hasMore}
                refreshFunction={handleRefresh}
                Loader={<Loader />}
                pullDownToRefresh={true}
            >
                <div className="friends-list">
                    {
                        isLoading && <Loader />
                    }
                    {!isLoading && myFollowings.length === 0 &&
                        <p className="not-found-msg">No followings found</p>
                    }
                    {
                        myFollowings && myFollowings.map((frd) => (
                            <UserCard user={frd} />
                        ))
                    }
                </div>
            </InfiniteScroll>
        </div>
    );
};

export default MyFollowings;
